import { useEffect, useRef } from "react";
import { useWSQuery } from "../query/helpers";

export function useDidFinishQueries(
  queries: ReturnType<typeof useWSQuery>[],
  onFinish: () => void
) {
  const didUpdate = useRef(false);

  useEffect(
    () => {
      if (didUpdate.current) {
        return;
      }

      if (queries.every(q => q.isFetched || q.isIdle)) {
        didUpdate.current = true;
        onFinish();
      }
    },
    queries.map(q => q.status)
  );
}
